import React, { useRef, useState, useEffect } from 'react';
import cn from 'classnames';
import Loader from 'components/UI/Loader';
import withIntersectionObserver from 'utils/googleMaps';
import { useOfficesMap } from '../hooks/mapHook';
import { getCoordinatesWithOffset } from 'utils/officesMap';
import * as styles from './OfficesMap.module.scss';

function OfficesMap({ offices, coordinates, setCoordinates, selectedOffice, setSelectedOffice }) {
  const mapWrapperRef = useRef(null);
  const [mapEl, setMapEl] = useState(null);
  const [loading, setLoading] = useState(true);

  const { mapInstance } = useOfficesMap(
    mapEl,
    offices,
    coordinates,
    setCoordinates,
    selectedOffice,
    setSelectedOffice,
  );

  useEffect(() => {
    if (selectedOffice) {
      setCoordinates(
        getCoordinatesWithOffset(
          selectedOffice.office.coordinates,
          selectedOffice.office.latOffset,
        ),
      );
    }
    setMapEl(mapWrapperRef.current);
    if (mapInstance) {
      setLoading(false);
    }
  }, [mapInstance]);

  const handleZoom = step => {
    if (mapInstance) {
      const currentZoom = mapInstance.getZoom();
      mapInstance.setZoom(currentZoom + step);
    }
  };

  return (
    <>
      {loading && <Loader theme="fullHeight" />}
      <div className={styles.mapWrapper}>
        <div ref={mapWrapperRef} className={styles.map} />
        {mapInstance && (
          <div className={styles.zoomControls}>
            <button
              className={cn(styles.zoomButton, styles.plusButton)}
              onClick={() => handleZoom(1)}
            />
            <button
              className={cn(styles.zoomButton, styles.minusButton)}
              onClick={() => handleZoom(-1)}
            />
          </div>
        )}
      </div>
    </>
  );
}

export default withIntersectionObserver(OfficesMap);
